<template>
  <div class="course-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <!--      <el-breadcrumb-item :to="{ path: '/onlineTraining/trainingPlan' }">培训任务</el-breadcrumb-item>-->
      <el-breadcrumb-item>培训任务</el-breadcrumb-item>
      <el-breadcrumb-item>培训人员</el-breadcrumb-item>
    </el-breadcrumb>
    <PublicSearch class="user-search" :searchData="searchData"
      @onSearch="() => { pageInfo.currentPage = 1; getData() }">
      <template #clazzName>{{ $store.state.institution }}</template>

      <template #right>
        <!-- <el-button v-buttonAuth="'system:Trainers:add'" size="small" type="primary" class="mg-btm20"
          @click="handleAction(5)">添加培训人员</el-button> -->
        <el-button size="small" type="primary" class="mg-btm20" @click="handleAction(5)">添加培训人员</el-button>
        <el-button v-buttonAuth="'system:Trainers:export'" size="small" type="primary" class="mg-btm20"
          @click="handleAction(4)">导出</el-button>
        <el-button size="small" class="mg-btm20" @click="$router.back()">返回</el-button>
      </template>
    </PublicSearch>
    <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">

      <template #deptName="item">{{ item.row.userArchive ? item.row.userArchive.deptName : '无' }}</template>

      <template #station="item">{{ item.row.userArchive ? item.row.userArchive.station : '无' }}</template>

      <template #workNo="item">{{ item.row.userArchive ? item.row.userArchive.workNo : '无' }}</template>

      <template #userName="item">
        <span :class="item.row.readSign ? 'col-f4d' : ''">
          {{ item.row.userArchive ? item.row.userArchive.userName : '无' }}
        </span>
      </template>
      <template #passNum="item">{{ item.row.passNum }}</template>

      <template #completionRate="item">
        <span :class="item.row.readSign ? 'col-f4d' : ''">

          {{ (item.row.passNum / item.row.courseNum).toFixed(2) * 100 }}%

        </span>
      </template>
      <el-table-column prop="userSex" width="250" label="操作">

        <template slot-scope="scope">
          <div class="d-flex fz14 col-29f cs-pit">
            <div v-buttonAuth="'system:Trainers:learningRecords'" class="operate" @click="handleAction(1, scope)">学习记录
            </div>
            <div v-buttonAuth="'system:Trainers:examRecords'" class="operate" @click="handleAction(2, scope)">考试记录</div>
            <el-popconfirm title="是否删除数据？" @confirm="handleAction(3, scope)">
              <template #reference>
                <div v-buttonAuth="'system:Trainers:delete'" class="col-f41 mg-lef10">删除</div>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
    <!-- 培训人员 -->
    <el-dialog :title="dialogOver.title" :close-on-click-modal="false" :visible.sync="dialogOver.visible" width="50%">
      <my-form ref="editForm1" :form-config="dialogOver.commonList" :dataForm="dialogOver.form"
        :formRules="dialogOver.rules">
      </my-form>
      <div slot="footer" class="dialog-footer text-rgt">
        <el-button size="small" @click='dialogOver.visible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="dialogOver.loading" @click="submitFormOver()">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import api from '../../../api/onlineTraining/traineeRec';
import { downloadFile, fileDownload } from "../../../utils/util";
import { deptTree } from "../../../api/dept";
import { archiveList } from '@/api/employee';
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm
  },
  data () {
    return {
      searchData: {
        inputList: [
          { label: '所属机构：', prop: 'clazzName' },
          {
            label: '所属部门',
            prop: 'deptId',
            props: 'dept',
            type: 'caScaDer',
            ref: 'casCaDerOne',
            options: [],
            casCaDerProps: { label: 'deptName', value: 'deptId', checkStrictly: true, Show: false, emitPath: false }
          },
          { label: '员工号：', prop: 'workNo', type: 'input', placeholder: '请输入员工号' },
          { label: '姓名：', prop: 'userName', type: 'input', placeholder: '请输入姓名' }
        ],
        searchQuery: {} //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '所属机构', prop: '', formatter: () => { return this.$store.state.institution } },
        { label: '所属部门', slot: 'deptName' },
        { label: '岗位', slot: 'station' },
        { label: '员工号', slot: 'workNo' },
        { label: '姓名', slot: 'userName' },
        { label: '课程总数', prop: 'courseNum' },
        { label: '学习总时长', prop: 'studyTimesText' },
        { label: '合格数', slot: 'passNum' },
        { label: '完成率', slot: 'completionRate' }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
      URL: envConfig.NODE_IMG_API,
      transferUserData: [],
      dialogOver: {
        title: '添加培训人员',
        visible: false,
        loading: false,
        commonList: [
          {
            type: 'select', prop: 'userIds', label: '选择人员', options: [],
            property: {
              clearable: true,
              filterable: true,
              multiple: true,
              'collapse-tags': true,
              'collapse-tags-tooltip': true,
            },
          },

        ],
        form: { userIds: [] },

        viewForm: {}, //  查看数据
        rules: {
          userIds: { required: true, message: '请选择人员', trigger: 'change' },
        }
      },
    }
  },
  created () {
    this.getDictionary();
    this.getData();
  },
  methods: {
    fileDownload,
    async getDictionary () {
      const res = await deptTree();
      this.searchData.inputList[1].options = res.data;
      const ress = await archiveList({});
      this.dialogOver.commonList[0].options = ress.data.map(i => { return { id: i.archiveId, label: i.userName + `(${i.deptName})` } })
    },
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        ...this.$route.query
      };
      const res = await api.traineePage(Object.assign(this.searchData.searchQuery, params));
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    async handleAction (index, data) {
      const type = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      switch (index) {
        case 1: //  学习记录
          await this.$router.push({
            path: '/onlineTraining/TrainersLearningRecords',
            query: { userId: data.row.userId, planId: data.row.planId, userName: data.row.userArchive.userName }
          })
          break;
        case 2: //  考试记录
          await this.$router.push({
            path: '/training/examinationRecord',
            query: {
              workNo: data.row.userArchive.workNo,
              userId: data.row.userArchive.userId,
              userName: data.row.userArchive.userName,
              planId: data.row.planId,
              planName: this.$route.query.planName
            }
          })
          break;
        case 3: //  删除
          await api.traineeRemove([data.row.traineeRecId], this.$route.query.planId);
          this.tableData.splice(data.$index, 1);
          this.pageInfo.total--;
          this.$message({ message: '删除成功', type: 'success' });
          break;
        case 4: //  导出
          downloadFile(await api.traineeExport({
            pageNum: this.pageInfo.currentPage,
            pageSize: this.pageInfo.pageSize,
            ...this.searchData.searchQuery
          }), type, `${this.$route.query.planName}-培训人员`);
          break;
        case 5: //  添加培训人员
          this.dialogOver.visible = true;
          this.dialogOver.title = '添加培训人员';
          break;
      }
    },
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    },
    submitFormOver () {
      this.$refs.editForm1.$refs.form.validate(async valid => {
        if (!valid) return false;
        const params = {
          "planId": this.$route.query.planId,
          "userIds": this.dialogOver.form.userIds
        }
        api.traineeAdd(params).then(res => {
          this.dialogOver.visible = false;
          this.getData();
          this.dialogOver.form.userIds = [];
          this.$message({ message: '添加成功', type: 'success' });
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;

  .user-search {
    margin-top: 20px;
  }

  .operate {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  .view-list {
    width: 70%;
    margin: 0 auto;
    font-size: 16px;

    .view-item {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;

      .view-label {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/trainingPlan/Trainers.vue